import { useMutation } from '@tanstack/react-query';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { updateRuleGroup } from 'Services';
import { RQ_UPDATE_RULE_GROUP } from 'Utils';

type Options = {
    mutationOptions?: any;
};

export default function useUpdateRuleGroup(
    adhocGroupId: number,
    { mutationOptions: { onSuccess, onError } = {} }: Options
) {
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useMutation(
        [RQ_UPDATE_RULE_GROUP, adhocGroupId],
        (newValue: Group[]) => updateRuleGroup(adhocGroupId, newValue[0].name, templateRepositoryId!),
        {
            onSuccess: (data, variables, context) => {
                if (onSuccess) {
                    onSuccess(data, variables, context);
                }
            },
            onError: async (error: any, variable, context) => {
                onError?.(error, variable, context);
            }
        }
    );
}
